<template>
  <v-dialog v-model="viewDialog" class="the-app-dialogs" persistent max-width="800px">
    <v-card>
      <v-layout row class="no-select not-printable" style="background-color:#09132f">
        <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
          <v-layout align-center>
            <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">fa-id-card-alt</v-icon>
            <span class="px-3">{{ $t("View Salesman's Information") }}</span>
          </v-layout>
        </h3>
        <v-spacer />
        <v-card-actions>
          <v-btn fab icon dark @click="$emit('hidemodal')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-layout>

      <v-card-title class="view-dialog-content grey lighten-3" id="printArea">
        <invoice-header class="only-for-print" />

        <v-layout column>
          <v-layout wrap class="invoice-content">
            <v-flex xs12 style="text-align: center" class="only-for-print" pb-3>
              <strong>{{ $t('Salesman') }}</strong>
            </v-flex>
            <v-flex xs12 class="pt-3">
              <div class="caption no-select">{{ $t('Name') }}</div>
              <strong>{{ salesmanInfo.sale_man_name }}</strong>
            </v-flex>

            <v-flex xs6 sm3 class="pt-3">
              <div class="caption no-select">{{ $t('Commission Type') }}</div>
              <strong v-if="salesmanInfo.commission_type">
                {{ $t(salesmanInfo.commission_type) }}
              </strong>
            </v-flex>

            <v-flex xs6 sm3 class="pt-3" v-if="salesmanInfo.commission_type !== 'No Commission'">
              <div class="caption no-select">
                {{ $t('Commission Percentage') }}
              </div>
              <strong v-if="salesmanInfo.sale_man_commission_percentage">
                {{ salesmanInfo.sale_man_commission_percentage | percentage }}
              </strong>
              <strong v-else>-</strong>
            </v-flex>

            <v-flex xs6 sm3 class="pt-3" v-if="salesmanInfo.commission_type !== 'No Commission'">
              <div class="caption no-select">{{ $t('Quota 1') }}</div>
              <strong v-if="salesmanInfo.sale_man_quota_1">
                {{ salesmanInfo.sale_man_quota_1 | currency }}
              </strong>
              <strong v-else>-</strong>
            </v-flex>

            <v-flex xs6 sm3 class="pt-3" v-if="salesmanInfo.commission_type !== 'No Commission'">
              <div class="caption no-select">{{ $t('Percentage 1') }}</div>
              <strong v-if="salesmanInfo.sale_man_commission_percentage_1">
                {{ salesmanInfo.sale_man_commission_percentage_1 | percentage }}
              </strong>
              <strong v-else>-</strong>
            </v-flex>

            <v-flex xs6 sm3 class="pt-3" v-if="salesmanInfo.commission_type !== 'No Commission'">
              <div class="caption no-select">{{ $t('Quota 2') }}</div>
              <strong v-if="salesmanInfo.sale_man_quota_2">
                {{ salesmanInfo.sale_man_quota_2 | currency }}
              </strong>
              <strong v-else>-</strong>
            </v-flex>

            <v-flex xs6 sm3 class="pt-3" v-if="salesmanInfo.commission_type !== 'No Commission'">
              <div class="caption no-select">{{ $t('Percentage 2') }}</div>
              <strong>
                {{ (salesmanInfo.sale_man_commission_percentage_2 || '-') | percentage }}
              </strong>
            </v-flex>

            <v-flex xs6 sm3 class="pt-3" v-if="salesmanInfo.commission_type !== 'No Commission'">
              <div class="caption no-select">{{ $t('Quota 3') }}</div>
              <strong v-if="salesmanInfo.sale_man_quota_3">
                {{ salesmanInfo.sale_man_quota_3 | currency }}
              </strong>
              <strong v-else>-</strong>
            </v-flex>

            <v-flex xs6 sm3 class="pt-3" v-if="salesmanInfo.commission_type !== 'No Commission'">
              <div class="caption no-select">{{ $t('Percentage 3') }}</div>
              <strong v-if="salesmanInfo.sale_man_commission_percentage_3">
                {{ salesmanInfo.sale_man_commission_percentage_3 | percentage }}
              </strong>
              <strong v-else>-</strong>
            </v-flex>

            <invoice-footer
              :showSignatureSection="false"
              :accountantName="''"
              :payerRecipientName="''"
              :payerOrRecipient="''"
              class="only-for-print"
            />
          </v-layout>
        </v-layout>
      </v-card-title>

      <v-divider light />

      <v-card-actions class="grey lighten-3 not-printable">
        <v-layout justify-end>
          <v-btn outline color="primary" @click="$emit('hidemodal')">
            {{ $t('Close') }}
          </v-btn>
          <v-btn color="primary" @click="printMe()">
            <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">print</v-icon>
            {{ $t('Print') }}
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>

    <image-viewer
      :imageSrc="salesmanInfo.sale_man_image"
      :maxWidth="600"
      :imageViewerDialog="dialogs.imageViewerDialog"
      @hidemodal="dialogs.imageViewerDialog = false"
    />
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'
import ignored from 'print-this'

export default {
  name: 'view-component',

  components: {
    imageViewer: () => import('@/views/_partials/AppImageViewer.vue'),
    invoiceHeader: () => import('@/views/_partials/invoiceHeader.vue'),
    invoiceFooter: () => import('@/views/_partials/invoiceFooter.vue')
  },

  props: {
    viewDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      systemCurrency: localStorage.systemCurrency,
      dialogs: {
        imageViewerDialog: false
      }
    }
  },

  computed: {
    ...mapGetters({
      baseUrls: 'misc/getBaseUrls',
      salesmanInfo: 'salesmen/getSalesmanInfo'
    })
  },

  updated() {
    document.addEventListener('keyup', e => {
      // if the "ESC" button was pressed and this dialog is shown, hide it
      if (e.keyCode === 27 && this.viewDialog) {
        this.$emit('hidemodal')
      }
    })
  },

  methods: {
    lnToBr(str) {
      return helpers.newLineToBreakLine(str)
    },

    printMe() {
      helpers.doPrinting()
    }
  }
}
</script>

<style scoped>
.only-for-print {
  display: none;
}
</style>
